import { createSlice } from '@reduxjs/toolkit';
import { resetSession, storeSession } from '../../util/storage';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    id: null,
    authkey: null,
  },
  reducers: {
    setSession: (state, action) => {
      const payload = action.payload;
      state.id = payload.id;
      state.authkey = payload.authkey;

      storeSession(state.id, state.authkey);
    },
    resetSession: (state, action) => {
      state.id = null;
      state.authkey = null;

      resetSession();
    }
  },
});

export const { setSession } = userSlice.actions;

export const getID = (state) => state.user.id;

export const getAuthKey = (state) => state.user.authkey;

export const getAuth = (state) => {
  if (state.user.id === null) {
    return {};
  }
  return {
    userid: state.user.id,
    authkey: state.user.authkey,
  };
}

export default userSlice.reducer;
